import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AssessmentState {
  currentAssessmentId: string | null;
  currentDomain: string;
  scores: Record<number, 0 | 1 | null>;
  basalItem: number | null;
  ceilingItem: number | null;
  
  setCurrentAssessment: (id: string | null) => void;
  setCurrentDomain: (domain: string) => void;
  setScore: (itemNumber: number, score: 0 | 1) => void;
  setBasalItem: (item: number | null) => void;
  setCeilingItem: (item: number | null) => void;
  resetScores: () => void;
}

export const useAssessmentStore = create<AssessmentState>()(
  persist(
    (set) => ({
      currentAssessmentId: null,
      currentDomain: 'cognitive',
      scores: {},
      basalItem: null,
      ceilingItem: null,
      
      setCurrentAssessment: (id) => set({ currentAssessmentId: id }),
      setCurrentDomain: (domain) => set({ currentDomain: domain }),
      setScore: (itemNumber, score) =>
        set((state) => ({
          scores: { ...state.scores, [itemNumber]: score }
        })),
      setBasalItem: (item) => set({ basalItem: item }),
      setCeilingItem: (item) => set({ ceilingItem: item }),
      resetScores: () => set({ scores: {}, basalItem: null, ceilingItem: null })
    }),
    {
      name: 'assessment-storage'
    }
  )
);

interface UIState {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen }))
}));
